<div class="col-sm-11 center-block">
    <div class="row">
        <div class="col-sm-12">
            <h1 tabindex="0" role="heading" aria-label="Oops, something went wrong!" aria-level="2">Oops, something went wrong!</h1>
            <h2 tabindex="0" role="heading" aria-label="Message" aria-level="2">Message:</h2>
            <h2 class="text-danger" tabindex="0" role="heading" [attr.aria-label]="message" aria-level="2">{{message}}</h2>
        </div>
    </div>
</div>
